export interface weeklySpecialDay {
  type: number;
  weekDay: number;
  id: number;
}

export interface specialDay {
  type: number;
  day: string;
  id: number;
}

export interface Calendar {
  id: number;
  key?: string;
  name?: string;
  description?: string | undefined;
  weeklySpecialDays?: weeklySpecialDay[];
  specialDays?: specialDay[];
}

export enum SpecialDayTypeEnum {
  DayOff = 0,
  WeeklyDayOff = 1,
  Working = 2,
  WeeklyWorking = 3,
  Holiday = 4,
  WeeklyHoliday = 5,
  HalfDay = 6,
  WeeklyHalfDay = 7
}

export enum WeekDayEnum {
  Sunday = 'Sunday',
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday'
}
